import { format, parseISO, differenceInCalendarDays } from 'date-fns';

// States that don't allow rate changes in the last X days of a policy term
export const noChargeInLastXDaysState = { AR: 60, MS: 60, SD: 60 };

// Check if policy is in a state with no-charge rule and within the specified days of end date
export const isInNoChargeWindow = (policy) => {
  if (!policy || !policy.geographicState || !policy.policy?.endDate) {
    return false;
  }

  const stateRule = noChargeInLastXDaysState[policy.geographicState];
  if (!stateRule) {
    return false;
  }

  const daysToEndPolicyTerm = differenceInCalendarDays(parseISO(policy.policy.endDate), new Date());
  return daysToEndPolicyTerm <= stateRule;
};

// Get the message for the no charge alert
export const getNoChargeAlertMessage = (policy) => {
  if (!policy || !policy.geographicState || !policy.policy?.endDate) {
    return '';
  }

  const formattedEndDate = format(parseISO(policy.policy.endDate), 'MM/dd/yyyy');

  return `Due to ${policy.geographicState} state regulations, rate changes are not allowed within ${noChargeInLastXDaysState[policy.geographicState]} days of the policy end date (${formattedEndDate}).`;
};
